import { track } from '@amplitude/analytics-browser';

// Own
import { LogEventParams } from './types';
export { EventType } from './event-type';

export const logEvent = (params: LogEventParams) => {
  track(params.event, params.props);
};
